module.exports = __webpack_public_path__ + "img/compress.3eb574da.svg";